import React from 'react';

import { motion } from 'framer-motion';

import WhatsAppButton from "../pages/WhatsAppButton";
import CourseContent from '../components/home/CourseContent';

import CoursePriceInfo from '../components/home/CoursePriceLu';
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: { duration: .3 }
  },
  exit: {
    x: '-100vw',
    transition: { ease: 'easeInOut' }
  }
}


const Curso = () => {
  return (
    <motion.main
      variants={containerVariants}
      initial="hidden"
      animate="visible"
    >

      <CourseContent/>
      <CoursePriceInfo/>
 
      <WhatsAppButton/>
    </motion.main>
  );
};

export default Curso;